import { render, staticRenderFns } from "./AppointmentInfoChips.vue?vue&type=template&id=586733b0&"
import script from "./AppointmentInfoChips.vue?vue&type=script&lang=js&"
export * from "./AppointmentInfoChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports